/** 工单提交页：与 handler 无关的静态配置，便于复用与扩展 */

export const MID_CONSIDER_TYPE_ENUM = {
  SPECIFIC: "固定审批人",
  AUTHOR_APPOINT: "提交人指定审批人",
  DIRECT_MANAGER: "提交人直接上级",
  REGIONAL_MANAGER: "提交人间接上级",
  HEAD_DEPT_MANAGER: "提交人一级部门负责人",
  SECOND_DEPT_MANAGER: "提交人二级部门负责人",
  TAIL_DEPT_MANAGER: "提交人最末部门负责人",
  HEAD_OF_CENTER: "提交人中心负责人",
  CONSULTING_REGIONAL_MANAGER: "提交人咨询区经",
  CONSULTING_SUPERVISOR: "提交人咨询主管",
};

export const WORK_ORDER_PROP_RULE_ENUM = {
  WORK_ORDER_TOPIC: "wkOrderTopic",
  WORK_ORDER_DESCRIBE: "remark",
  IMAGE_UPLOAD: "attachments",
  ATTACHMENTS_UPLOAD: "attachments",
  PRIORITY: "priority",
  RELATION_WORK_ORDER: "relationWorkOrderIds",
  CUSTOMER_INFO: "customerInfoList",
  ATTENTION_USER: "newFollowPeoples",
  WEBSITE_INFO: "webInfo",
  COMPANY_MODEL: "companyInfo",
  MONEY_MODEL: "money",
  LABEL_MODEL: "labelName",
  DOCTOR_INFO: "doctorInfo",
  REGIONAL: "regional",
  ACCURATE_PROJECT_INFO: "accurateProjectInfo",
  ACCURATE_CUSTOMER_INFO: "accurateCustomerInfo",
  ACCURATE_COMPANY_MODEL: "accurateCompanyInfo",
  BUSINESS_TYPE: "businessType",
};

export const WORK_ORDER_TEMPLATE_ENUM = [
  {
    isRequired: true,
    moduleName: "WORK_ORDER_TOPIC",
    sortNum: 0,
    label: "问题标题",
  },
  {
    isRequired: true,
    moduleName: "WORK_ORDER_DESCRIBE",
    sortNum: 0,
    label: "问题描述",
  },
  {
    isRequired: false,
    moduleName: "IMAGE_UPLOAD",
    sortNum: 0,
    label: "图片上传",
  },
  {
    isRequired: false,
    moduleName: "ATTACHMENTS_UPLOAD",
    sortNum: 0,
    label: "附件上传",
  },
  {
    isRequired: false,
    moduleName: "PRIORITY",
    sortNum: 0,
    label: "优先级",
  },
  {
    isRequired: false,
    moduleName: "RELATION_WORK_ORDER",
    sortNum: 0,
    label: "关联工单",
  },
  {
    isRequired: false,
    moduleName: "CUSTOMER_INFO",
    sortNum: 0,
    label: "用户信息",
  },
  {
    isRequired: false,
    moduleName: "ATTENTION_USER",
    sortNum: 0,
    label: "关注人",
  },
  {
    isRequired: false,
    moduleName: "WEBSITE_INFO",
    sortNum: 0,
    label: "网站信息",
  },
  {
    isRequired: false,
    moduleName: "COMPANY_MODEL",
    sortNum: 0,
    label: "相关机构",
  },
  {
    isRequired: false,
    moduleName: "MONEY_MODEL",
    sortNum: 0,
    label: "涉及金额",
  },
  {
    isRequired: false,
    moduleName: "LABEL_MODEL",
    sortNum: 0,
    label: "标签",
  },
  {
    isRequired: false,
    moduleName: "DOCTOR_INFO",
    sortNum: 0,
    label: "医生信息",
  },
  {
    isRequired: false,
    moduleName: "REGIONAL",
    sortNum: 0,
    label: "地区信息",
  },
  {
    isRequired: false,
    moduleName: "ACCURATE_PROJECT_INFO",
    sortNum: 0,
    label: "关联项目信息",
  },
  {
    isRequired: false,
    moduleName: "ACCURATE_CUSTOMER_INFO",
    sortNum: 0,
    tips: "（用户ID或手机号必填其一）",
    label: "精准客户信息",
  },
  {
    isRequired: false,
    moduleName: "ACCURATE_COMPANY_MODEL",
    sortNum: 0,
    label: "精准机构信息",
  },
  {
    isRequired: false,
    moduleName: "BUSINESS_TYPE",
    sortNum: 0,
    label: "业务类型",
  },
];

export const SEAL_EXTRA_FILE_TYPES = [".jpg", ".jpeg", ".png", ".gif"];

export const SEAL_QUALIFICATION_NAME_OPTIONS = [
  "营业执照(正副本)",
  "第二类医疗器械经营备案凭证",
  "互联网药品信息服务资格证书(正副本)",
  "增值电信业务经营许可证(ICP)",
  "广播电视节目制作经营许可证",
  "商标注册证",
  "卫生许可证",
  "计算机软件著作权登记证书(软著)",
  "开户许可证",
  "韶关颜所医学美容门诊有限公司",
  "诊所备案凭证(医疗许可证)",
  "医疗执业许可证(正副本)",
];

export const SEAL_PURPOSE_OPTIONS = [
  "业务使用办理（渠道注册，备案，年审）",
  "公司类办理(如注册、变更、诉讼等)",
];
